import {Injectable, inject} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHandler, HttpEvent} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {EventManager, EventWithContent} from '../service/event-manager.service';
import {AlertErrorService} from '@core/service/alert-error.service';

export const SKIP_ERROR_HANDLER_HEADER = 'X-Skip-Error-Handler';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  errorService = inject(AlertErrorService);

  constructor(private readonly eventManager: EventManager) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipError = request.headers.has(SKIP_ERROR_HANDLER_HEADER);
    const cleanRequest = skipError
      ? request.clone({ headers: request.headers.delete(SKIP_ERROR_HANDLER_HEADER) })
      : request;

    return next.handle(cleanRequest).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          if (!skipError) {
            this.eventManager.broadcast(new EventWithContent('httpError', err));
          }
        },
      }),
    );
  }
}
